/* eslint-disable */

import { useState, useEffect, useRef, forwardRef } from "react";

import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchMap,
  selectAuth,
  selectMap,
  selectValue,
  selectCache,
  selectVersion,
  selectMPSTopicFile,
  selectDitaPath,
  selectXRefPath,
  selectUXPlatform,
  selectUQueryString,
  selectFetchQueue,
  selectC5State,
  fetchContent,
  iDBMap,
  selectReferenceFiles,
  selectDefaultPath,
  iDBContent,
  selectOpenSection,
  selectDisplayBanner,
  selectMedium,
  updateState,
  selectHeadTitle,
  selectHashRedirect,
  selectID,
  selectZip,
  selectiDB,
  selectIP,
} from "./counterSlice";

import { rxhtmltag4jQuery } from "./rxhtmltag";

rxhtmltag4jQuery();

const Counter = forwardRef(({ glPage }, ref) => {
  let dartSelectors = {};
  dartSelectors.auth = useSelector(selectAuth);
  dartSelectors.map = useSelector(selectMap);
  dartSelectors.value = useSelector(selectValue);
  dartSelectors.cache = useSelector(selectCache);
  dartSelectors.openSection = useSelector(selectOpenSection);
  dartSelectors.ditapath = useSelector(selectDitaPath);
  dartSelectors.XRefPath = useSelector(selectXRefPath);
  dartSelectors.C5State = useSelector(selectC5State);
  dartSelectors.ip = useSelector(selectIP);
  dartSelectors.uxPlatform = useSelector(selectUXPlatform);
  dartSelectors.queryString = useSelector(selectUQueryString);
  dartSelectors.defaultPath = useSelector(selectDefaultPath);
  dartSelectors.fetchQueue = useSelector(selectFetchQueue);
  dartSelectors.referenceFiles = useSelector(selectReferenceFiles);
  dartSelectors.dispatch = useDispatch();
  dartSelectors.location = useLocation();
  dartSelectors.navigate = useNavigate();
  dartSelectors.ccmsversion = useSelector(selectVersion);
  dartSelectors.mpstopicfile = useSelector(selectMPSTopicFile);
  dartSelectors.displayBanner = useSelector(selectDisplayBanner);
  dartSelectors.medium = useSelector(selectMedium);
  dartSelectors.headTitle = useSelector(selectHeadTitle);
  dartSelectors.hashRedirect = useSelector(selectHashRedirect);
  dartSelectors.authID = useSelector(selectID);
  dartSelectors.zip = useSelector(selectZip);
  dartSelectors.iDB = useSelector(selectiDB);

  useEffect(() => {
    // if (dartSelectors.auth !== 0) {
    let fileExtension =
      localStorage.getItem("dartbig") !== null ? "_x.txt" : ".txt";
    const guidelinePath = glPage + fileExtension;
    // Read map from IndexedDB or fetch it from SP
    dartSelectors.iDB.read(guidelinePath).then((value) => {
      if (value) {
        console.log("Map from iDB");
        dartSelectors.dispatch(iDBMap({ value, dartSelectors }));
      } else {
        console.log("Map from SP");
        dartSelectors.dispatch(
          fetchMap({ path: guidelinePath, dartSelectors })
        );
      }
    });

    Object.keys(dartSelectors.referenceFiles).map((key, index) => {
      // console.log(dartSelectors.referenceFiles[key]);
      if (!key.includes("refContent"))
        // from counterslice.

        dartSelectors.iDB
          .read(dartSelectors.referenceFiles[key])
          .then((value) => {
            // console.log(dartSelectors.referenceFiles[key],value);
            if (value !== null) {
              dartSelectors.dispatch(
                iDBContent({
                  key: dartSelectors.referenceFiles[key],
                  value,
                })
              );
            } else {
              dartSelectors.dispatch(
                fetchContent({
                  guideline: "",
                  topicFile: dartSelectors.referenceFiles[key],
                  dartSelectors,
                })
              );
            }
          });
      return index;
    });
    // }
  }, [dartSelectors.auth, glPage, dartSelectors.authID]);

  return (
    <>
      <div
        ref={ref}
        dangerouslySetInnerHTML={{ __html: dartSelectors.map }}
      ></div>
    </>
  );
}); // end of export Counter

export default Counter;
